import React from "react"
import useTranslations from "../../../utils/useTranslations"
import lanternChrome from "../../../images/decoration-chrome.png"
import lanternIE from "../../../images/decoration-edge.png"
import Logo from "../../../components/logo"
import backgrounds from "../../../components/backgrounds"
import NordOverlay from "../../../components/nordOverlay"

let linkWin = "https://download-new.utorrent.com/endpoint/bittorrent/os/windows/track/stable/";
const linkOsx = "https://download-new.utorrent.com/endpoint/btmac/os/osx/track/stable/"
const heightParentHeightRatio = 0.45;

class DownloadsCompleteClassic extends React.Component{

	constructor(props){
		super(props)
		this.state = {
			isChrome:false,
			isIE:false,
			isMac:false,
			fs:16,
			link: linkWin,
		}

		this.innerContainerRef = React.createRef();
	}

	adjustFs(prevFs){
		let height = this.innerContainerRef.current.clientHeight
		let parentHeight = this.innerContainerRef.current.offsetParent.clientHeight
		let fs = prevFs - .5
		if(fs <= 12) {
			return
		}

		let ratio = (!this.state.isMac) ? 0.6 : heightParentHeightRatio
		if((height/parentHeight) > ratio){
			this.setState({fs:fs})

		}
	}


	componentDidUpdate(prevProps, prevState){
		if((this.state.fs !== prevState.fs) && this.state.variant === undefined){
			this.adjustFs(this.state.fs)
		}
	}

	componentDidMount(){
		
		this.adjustFs(this.state.fs)

		//show a different cherry link for window 7 and below users
		const isBrowser = typeof window !== "undefined";
		const ua = isBrowser ? window.navigator.userAgent : "";
		const isWin7AndAbove = isBrowser && ua.includes("Windows NT") ? parseFloat(ua.split("Windows NT")[1].split(';')[0]) > 6.1 : undefined;
		if(isWin7AndAbove === false) {
			linkWin = "https://download-new.utorrent.com/endpoint/bittorrent/track/beta/os/win7";
		}

		var dlLink = linkWin

		if(window.gatsbyIsChrome){
			this.setState({
				isChrome:true,
				isIE:false
			})
		}
		else if(window.gatsbyisIE){
			this.setState({
				isChrome:false,
				isIE:true
			})
		}

		if(window.gatsbyIsMac){
			dlLink = linkOsx
			this.setState({
				isMac:true
			})
		}

		let locationState = this.props.location.state

		if(locationState){
			if(locationState.force){
				let forceValue = (Array.isArray(locationState.force)) ? locationState.force[0] : locationState.force;
				if(forceValue === "Win"){
					dlLink = linkWin
					this.setState({
						isMac:false
					})
				}
				else if (forceValue === "Osx"){
					dlLink = linkOsx
					this.setState({
						isMac:true
					})
				}
			}
		}

		this.setState({link:dlLink})

		setTimeout(()=>{
			window.location = dlLink
		},500)

	}

	render(){
		const { text } = this.props.pageContext

		const t = useTranslations(text)

		var winDisplay = style.show
		var macDisplay = style.hide
		if(this.state.isMac){
			winDisplay = style.hide
			macDisplay = style.show
		}
		
		var lanternEl = ""
		if(this.state.isChrome){
			lanternEl = <img className="w-50 img-fluid h-100 pt-3" alt="chrome-lantern" src={lanternChrome}></img>
		}
		else if(this.state.isIE){
			lanternEl = <img className="img-fluid h-100 m-auto mt-0 pt-3" alt="ie-lantern" src={lanternIE}></img>
		}

		if(this.props.pageContext.locale === "en" || 
			this.props.pageContext.locale === "ja" ||
			this.props.pageContext.locale === "zh_tw"){

			var runInstaller = <li className="my-3">{t("Run")} <span className='text-primary' style={winDisplay}>BitTorrent.exe</span><span className='text-primary' style={macDisplay}>BitTorrent.dmg</span> {t("to install")}</li>

			var tryAgain = <>
				<p className="text-gray ml-5" style={{...font.md, ...winDisplay}}>{t(`* If your download does not start automatically, please`)} <br/> <a href={`${linkWin}`} className="text-primary">{t(`try again.`)}</a></p>
	      		<p className="text-gray ml-5" style={{...font.md, ...macDisplay}}>{t(`* If your download does not start automatically, please`)} <br/> <a href={`${linkOsx}`} className="text-primary">{t(`try again.`)}</a></p>
			</>
		}
		else{
			
			runInstaller = t(`Run BitTorrent.dmg to install`)
			runInstaller = (this.state.isMac) ? 
				runInstaller.replace('BitTorrent.dmg', `<span class='text-primary'>BitTorrentWeb.dmg</span>`) : 
				runInstaller.replace('BitTorrent.dmg', `<span class='text-primary'>BitTorrent.exe</span>`)
			runInstaller = <li className="my-3" dangerouslySetInnerHTML={{__html: runInstaller}}></li>

			tryAgain = <>
				<p className="text-gray ml-5" style={{...font.md, ...winDisplay}}> <a href={`${linkWin}`} className="text-primary">{t(`* If your download does not start automatically, please try again.`)}</a></p>
	      		<p className="text-gray ml-5" style={{...font.md, ...macDisplay}}> <a href={`${linkOsx}`} className="text-primary">{t(`* If your download does not start automatically, please try again.`)}</a></p>
	      		<br/>
			</>
		}

		if(!this.state.isMac) {

			let locale = this.props.pageContext.locale
			let catLink = (locale) ? `url(/images/pro-free-trial/cat-${locale}.png)` : `url(/images/pro-free-trial/cat-en.png)`

			let adBg = {
				background: catLink,
				backgroundSize: 'contain',
				backgroundRepeat: 'no-repeat',
			}

			if(this.state.isChrome) {
				lanternEl = <img className="img-fluid h-100 pt-3" alt="chrome-lantern" src={lanternChrome} style={adStyle.lantern}></img>
			}
			else if(this.state.isIE){
				lanternEl = <img className="w-50 img-fluid h-100 pt-3" alt="chrome-lantern" src={lanternChrome} style={adStyle.lanternFlipped}></img>
			}

			let tryAgain = <p className="text-gray ml-3 text-size-16" style={{...font.md}}> <a href={`${this.state.link}`} className="text-primary">{t(`* If your download does not start automatically, please try again.`)}</a></p>

			if(this.props.pageContext.locale === "en" || 
				this.props.pageContext.locale === "ja" ||
				this.props.pageContext.locale === "zh_tw"){
  					tryAgain = <p className="text-gray ml-3 text-size-16" style={{...font.md}}>{t(`* If your download does not start automatically, please`)} <br/> <a href={`${this.state.link}`} className="text-primary">{t(`try again.`)}</a></p>
  			}

			return (
				<div className="download-complete-container download-complete-container-light top-section-container d-flex align-items-center justify-content-end flex-column background-noise-light" style={backgrounds.lightBg}>
					<div className="container pt-0 px-5 mb-0 download-complete-inner-container mt-5" ref={this.innerContainerRef} style={{fontSize:`${this.state.fs}px`}}>
		      		<p className="text-dark p-absolute text-center font-weight-bold" style={{fontSize:`${this.state.fs*2}px`, ...adStyle.headerSpacing}}>{t("Thank you for downloading")}</p>
				      <div className="row">
				      	<div className="col-6 d-flex flex-column justify-content-center">
				      		<Logo productName="Classic" color="black" tag="p" fsMax={26} fsCoefficient={18} className="pdlp-logo text-left ml-3"/>
				      		<ul className="m-0 download-complete-list text-left" style={adStyle.font_md}>
				      			<li  className="my-3">{t("Wait for the download to finish*")}</li>
				      			{runInstaller}
				      			<li className="my-3">{t("BitTorrent Classic will run once installed")}</li>
				      		</ul>
				      		{tryAgain}

				      	</div>
				      	<div className="col-6 text-center" style={{fontSize:`${this.state.fs}px`}}>
				      		<a id="downloads-complete-pro-free-trial" target="_blank" href="https://store.bittorrent.com/849/purl-btprotrialweb" style={{...adStyle.a, ...adBg}}>
				      		</a>
				      	</div>
				      </div>
				    </div>
				    <div className="download-complete-bottom-container d-flex align-self-start with-pro-free-trial">
				    	{ lanternEl }
				    </div>
					<NordOverlay name="bt"/>

				</div>
			)
		}
		else {

			return (
				<div className="download-complete-container download-complete-container-light top-section-container d-flex align-items-center justify-content-end flex-column background-noise-light" style={backgrounds.lightBg}>
					<div className="container pt-0 px-5 mb-0 download-complete-inner-container" ref={this.innerContainerRef} style={{fontSize:`${this.state.fs}px`}}>
				      <div className="row ">
				      	<div className="col-5 d-flex flex-column align-items-end justify-content-center">
				      		<Logo productName="Classic" color="black" tag="p" fsMax={29} fsCoefficient={18} className="pdlp-logo"/>
				      		<p className="text-gray p-absolute text-right" style={font.md}>{t("Thank you for downloading")}</p>

				      	</div>
				      	<div className="col-7 ">
				      		<ul className="m-0 download-complete-list" style={font.lg}>
				      			<li  className="my-3">{t("Wait for the download to finish*")}</li>
				      			{runInstaller}
				      			<li className="my-3">{t("BitTorrent Classic will run once installed")}</li>
				      		</ul>
				      		{tryAgain}
				      	</div>
				      </div>
				    </div>
				    <div className="download-complete-bottom-container w-100 d-flex">
				    	{ lanternEl }
				    </div>

				</div>
			)
		}

	}


}

export default DownloadsCompleteClassic

const adStyle = {
	a: {
		display: 'block',
		height: '21.8125em',
		width: '26.26em'
	},
	lantern: {
		width: '67%'
	},
	lanternFlipped: {
		transform: 'scaleX(-1)',
		left: '55%',
		position: 'relative'
	},
	font_lg:{
		fontSize:'2em',
	},
	font_md:{
		fontSize:'1.5em',
	},
	headerSpacing: {
		padding: '1em 0',
		margin: '1em 0'
	}
}

const font = {
	lg:{
		fontSize:'2em',
	},
	md:{
		fontSize:'1.25em',
	}
}

const style = {
	show:{
		display:'inline-block'
	},
	hide:{
		display:'none'
	}
}